import { mapObjIndexed, pathOr } from 'ramda'

export default (defaults, values) =>
  mapObjIndexed((val, key) => pathOr(val, [key], values), defaults)
